import {
  EventDataFragment,
  useUpdateConsultantEventLogPinMutation
} from "@bonliva-crm/graphql";
import { HookProps } from "../utils/hook-props";

export function useUpdateConsultantEventLogPin(props: HookProps) {
  const [updateConsultantEventLogPinMutation] = useUpdateConsultantEventLogPinMutation({
    onError: (error) => {
      console.error(error);
      props.onError && props.onError(error);
    },
    onCompleted: () => {
      props.onCompleted && props.onCompleted();
    }
  });

  const updateConsultantEventLogPin = ({ event }: { event: EventDataFragment }) => {
    props.onBeforeCall && props.onBeforeCall();
    updateConsultantEventLogPinMutation({
      variables: { eventId: event._id },
      optimisticResponse: () => {
        return {
          pinConsultantEvent: {
            ...event,
            UpdatedBy: null,
            Sticky: !event.Sticky
          }
        };
      }
    });
  };

  return { updateConsultantEventLogPin };
}
